import { Provider } from '@angular/core';
import { CHAT_API_CONFIG, ChatApiConfig } from '@bioreferencehealth/chat-lib';
import { environment } from 'src/environments/environment';
import { ChatTokenService } from '../services/chat-token.service';

// Must be registered at the application root (see `main.ts`), NOT at route or component level:
// `@bioreferencehealth/chat-lib`'s `ChatService` is `providedIn: 'root'`, so it always resolves
// `CHAT_API_CONFIG` through the root environment injector the first time it's constructed, no
// matter which component/route triggered that construction. Route/component-level overrides of the
// token are never visible to it, which previously caused chat requests to silently fall back to the
// library's own default endpoints. Registering this only at root does mean `@bioreferencehealth/chat-lib`
// and its `chart.js` dependency are no longer excluded from the eagerly loaded initial bundle.
export function provideChatApiConfig(): Provider {
  return {
    provide: CHAT_API_CONFIG,
    useFactory: (tokenService: ChatTokenService): ChatApiConfig => ({
      MESSAGE: `${environment.chatApiUrl}/cortex/message`,
      MESSAGE_STREAM: `${environment.chatApiUrl}/cortex/message/stream`,
      FEEDBACK: `${environment.chatApiUrl}/cortex/feedback`,
      CHAT_SUGGESTIONS: `${environment.chatApiUrl}/chat-suggestions`,
      getAuthHeaders: (): Record<string, string> => {
        const token = tokenService.getToken();
        return token ? { Authorization: `Bearer ${token}` } : {};
      }
    }),
    deps: [ChatTokenService]
  };
}
